import { Box, Stack } from '@mui/material';
import { keyframes } from '@mui/system';

const dotsBounce = keyframes`
  0%, 80%, 100% { transform: scale(0); opacity: .6; }
  40% { transform: scale(1); opacity: 1; }
`;

export default function TypingAnimation() {
  const delayOptions = [150, 300, 450];

  return (
    <Box
      sx={{
        mb: 2,
        ml: 1,
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '12px',
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: '12px',
        bgcolor: 'common.white',
        px: 1,
        py: 1.5,
        width: '3.5rem',
      }}
    >
      <Stack direction="row" spacing={0.5}>
        {delayOptions.map((delay) => (
          <Box
            key={delay}
            sx={{
              width: 7,
              height: 7,
              borderRadius: '50%',
              bgcolor: '#6c757d',
              opacity: 0.7,
              animation: `${dotsBounce} 1.4s infinite ease-in-out both`,
              animationDelay: `${delay}ms`,
            }}
          />
        ))}
      </Stack>
    </Box>
  );
}
